import { FormGroup, Grid, IconButton, Tooltip } from "@mui/material";
import * as React from "react";
import styled from "styled-components";
import { IngestProtocol } from "../../../__generated__/globalTypes";
import { CopyAll } from "@mui/icons-material";
import { copyToClipboard } from "../../CopyLabel/CopyLabel";
import ChannelIngestAudioTracks, { ChannelStreamConfigAudioInputWithId } from "./ChannelIngestAudioTracks";

interface Props {
    disabled: boolean;
    ingestProtocol: IngestProtocol;
    ingestUrl: string;
    onChangeIngestUrl: (url: string) => void;
    audioTracks: ChannelStreamConfigAudioInputWithId[];
    onChangeAudioTracks: (tracks: ChannelStreamConfigAudioInputWithId[]) => void;
}

const Input = styled.input.attrs((props: { disabled: boolean }) => ({
    disabled: props.disabled,
}))`
    font-size: 14px;
    border: 1px solid ${(props) => props.theme.lightGrayBottom};
    border-radius: 6px;
    padding: 6px 10px;
    outline: rgba(0, 0, 0, 0.6);
    color: #696969;
    width: 100%;
    cursor: ${(props) => (props.disabled === true ? "not-allowed" : "text")};
`;

const Label = styled.label`
    font-size: 13px;
    font-weight: bolder;
    width: 80px;
`;

const Helper = styled.div`
    font-size: 13px;
    color: ${(props) => props.theme.gray};
`;

function ChannelIngestSettingsPull({
    ingestProtocol,
    ingestUrl,
    onChangeIngestUrl,
    disabled,
    audioTracks,
    onChangeAudioTracks,
}: Props) {
    function isValidUrl(): boolean {
        if (ingestProtocol === IngestProtocol.rtmp) {
            return ingestUrl.startsWith("rtmp://") || ingestUrl.startsWith("rtmps://");
        }
        if (ingestProtocol === IngestProtocol.srt) {
            return ingestUrl.startsWith("srt://");
        }
        return true;
    }

    return (
        <>
            <Grid container>
                <Grid item xs={12}>
                    <FormGroup>
                        <Label>URL:</Label>
                        <div style={{ display: "flex", width: "100%", flexDirection: "row", gap: "10px" }}>
                            <Input
                                type="text"
                                value={ingestUrl}
                                onChange={(e) => onChangeIngestUrl(e.target.value)}
                                disabled={disabled}
                            />

                            <Tooltip title="Copy">
                                <IconButton size="small" onClick={() => copyToClipboard(ingestUrl)}>
                                    <CopyAll fontSize="small" />
                                </IconButton>
                            </Tooltip>
                        </div>
                        {!isValidUrl() && (
                            <Helper>
                                Not a valid {ingestProtocol === IngestProtocol.rtmp ? "RTMP(s)" : "SRT"} url. Should
                                start with {ingestProtocol === IngestProtocol.rtmp ? "rtmp:// or rtmps://" : "srt://"}
                            </Helper>
                        )}
                    </FormGroup>
                </Grid>
                {ingestProtocol === IngestProtocol.srt && (
                    <Grid item xs={12} style={{ marginTop: "8px" }}>
                        <FormGroup>
                            <Label>Audio tracks:</Label>
                            <ChannelIngestAudioTracks
                                tracks={audioTracks}
                                disabled={disabled}
                                onChangeTracks={(tracks: ChannelStreamConfigAudioInputWithId[]) =>
                                    onChangeAudioTracks(tracks)
                                }
                            />
                        </FormGroup>
                    </Grid>
                )}
            </Grid>
        </>
    );
}

export default ChannelIngestSettingsPull;
